// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__SyZdy","productName":"Table_productName__3kl-V"};